module.exports = __webpack_public_path__ + "static/media/last.1b600915.png";